import React from "react";
import JonasImg from "./profile-pics/jonas.jpg";
import AsmundImg from "./profile-pics/asmund.jpg";
import KristianImg from "./profile-pics/kristian.jpeg";
import LuddeImg from "./profile-pics/ludde.jpg";
import TomasImg from "./profile-pics/tomas.jpg";
import JuliaImg from "./profile-pics/julia.jpg";

type Person = {
    name: string
    role: string
    linkedInURL: string
    profilePic: string
}

export function AboutUsPage() {

    const people: Person[] = [
        {
            name: "Jonas Dammen",
            linkedInURL: "https://www.linkedin.com/in/jonas-dammen-6b897ba3/",
            role: "Data Scientist / ML Engineer / Fullstack Developer",
            profilePic: JonasImg
        },
        {
            name: "Åsmund Brekke",
            linkedInURL: "https://www.linkedin.com/in/aasmundbrekke/",
            role: "Data Scientist / Backend Developer / Architect",
            profilePic: AsmundImg
        },
        {
            name: "Kristian Andersen Hole",
            linkedInURL: "https://www.linkedin.com/in/kristian-andersen-hole-513421bb/",
            role: "Fullstack Developer / Architect",
            profilePic: KristianImg
        },
        {
            name: "Ludvig Alexander Løddesøl",
            linkedInURL: "https://www.linkedin.com/in/ludlodd/",
            role: "Backend Developer / Business Insight / Manager",
            profilePic: LuddeImg
        },
        {
            name: "Tomas Roaldsnes",
            linkedInURL: "https://www.linkedin.com/in/tomas-roaldsnes-4b754bb3/",
            role: "Frontend Developer / UX Designer / Fishing Expert",
            profilePic: TomasImg
        },
        {
            name: "Julia Ortheden",
            linkedInURL: "https://www.linkedin.com/in/julia-ortheden-6a0623134/",
            role: "Data Scientist / ML Engineer",
            profilePic: JuliaImg
        },
    ];

    return <>
        <div style={{ padding: '10px', marginTop: '40px' }}>
            <h3>
                Winners of <a href="https://www.nora.ai/">NORA's</a> (Norwegian Artificial Intelligence Research Consortium) <a href="https://www.nora.ai/competition/sustainable-fishing.html"><br />FishAI: Sustainable Commercial Fishing</a> competition.
            </h3>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {people.map(person =>
                <div style={{ margin: '24px', border: '2px solid black', borderRadius: '8px', padding: '20px', width: '350px', display: 'flex', flexDirection: 'column' }}>
                    <div><h3 style={{ marginTop: '0' }}>{person.name}</h3></div>
                    <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '18px', paddingTop: '8px' }}>
                        <img
                            style={{ width: '120px', height: '120px', borderRadius: '50%', objectFit: 'cover' }}
                            src={person.profilePic}
                            alt={person.name} />
                    </div>
                    <div><kbd>{person.role}</kbd></div>
                    <div style={{ display: 'flex', justifyContent: 'end', marginTop: 'auto' }}>
                        <a style={{ fontSize: '18px' }} href={person.linkedInURL}>LinkedIn</a>
                    </div>
                </div>)}
        </div>
    </>;
}

